const indexItems = [
  {
    title: '娱乐圈黑料全记录',
    desc: '明星塌房、恋情曝光、选秀黑幕等娱乐圈黑料事件合集',
    icon: 'ri-movie-line',
    count: '328篇',
    color: 'primary' as const,
  },
  {
    title: '网红圈瓜田故事',
    desc: '头部主播恩怨、直播带货翻车、网红塌房全追踪',
    icon: 'ri-live-line',
    count: '256篇',
    color: 'accent' as const,
  },
  {
    title: '互联网大厂内幕',
    desc: '科技巨头内部斗争、高管变动、裁员风波深度揭秘',
    icon: 'ri-building-line',
    count: '245篇',
    color: 'primary' as const,
  },
  {
    title: '财经圈黑幕追踪',
    desc: '上市公司财务疑云、内幕交易、资本运作暗箱全记录',
    icon: 'ri-money-dollar-circle-line',
    count: '167篇',
    color: 'accent' as const,
  },
  {
    title: '体育圈争议事件',
    desc: '转会黑幕、裁判争议、兴奋剂事件等体育圈黑料盘点',
    icon: 'ri-football-line',
    count: '143篇',
    color: 'primary' as const,
  },
  {
    title: '社会热点深挖',
    desc: '公共事件背后的黑料揭秘与后真相持续性跟踪报道',
    icon: 'ri-earth-line',
    count: '312篇',
    color: 'accent' as const,
  },
  {
    title: '品牌翻车实录',
    desc: '知名品牌公关危机、虚假宣传、产品质量问题全汇总',
    icon: 'ri-alert-line',
    count: '134篇',
    color: 'primary' as const,
  },
  {
    title: '学术造假档案',
    desc: '论文抄袭、数据造假、学术不端事件的完整调查记录',
    icon: 'ri-book-open-line',
    count: '98篇',
    color: 'accent' as const,
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          按主题分类浏览黑料故事，找到你最关注的吃瓜领域
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-200/60 rounded-lg p-5 cursor-pointer transition-all duration-300 hover:border-primary-500/30 hover:bg-background-200/50"
            >
              <div
                className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/15 text-primary-400'
                    : 'bg-accent-500/15 text-accent-400'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1.5 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs text-foreground-600">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}